export const CARD_ADD_CONSTANTS = {
  EMIT: {
    VIEW_FORM_TEMP: "viewFormTemp",
    ADD_FORM: "addForm"
  }
};
